/**
 * オブジェクトの配列を指定したキーとデータ型に基づいてソートします。
 *
 * @param {Array<Object>} array - ソートするオブジェクトの配列
 * @param {string} key - ソートに使用するオブジェクトのキー
 * @param {'ascend' | 'descend'} [order='descend'] - ソートの順序。'ascend' または 'descend'。デフォルトは 'descend'。
 * @param {'numeric' | 'string'} [type='string'] - ソートの基準となるデータの型。'numeric' または 'string'。デフォルトは 'string'。
 */
export function objectSort(array, key, order = 'descend', type = 'string') {
    const sortOrder = order === 'ascend' ? 1 : -1;

    array.sort((obj1, obj2) => {
        let v1 = obj1[key];
        let v2 = obj2[key];

        if (type === 'numeric') {
            v1 = Number(v1);
            v2 = Number(v2);
        } else {
            v1 = String(v1);
            v2 = String(v2);
        }

        return v1 > v2 ? sortOrder : v1 < v2 ? -sortOrder : 0;
    });
}
